import './App.css';
import './MediaQueries.css';
import './GreyWolf.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import ScrollToTop from './Components/ScrollToTop';
import Header from './Components/Header';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import Menu from './Pages/Menu';
import EventDetails from './Pages/EventDetails';
import BookEnquiry from './Pages/BookEnquiry';
import EventCheckout from './Pages/EventCheckout';
import BookingStatus from './Pages/BookingStatus';
import TicketResend from './Pages/TicketResend';
import TicketView from './Pages/TicketView';
import NotFound from './Pages/NotFound';
import LegalPage from './Pages/LegalPage';
import { termsMarkdown, refundPolicyMarkdown, TERMS_PATH, REFUND_POLICY_PATH, PRIVACY_PATH } from './data/legal';
import { privacyMarkdown } from './data/privacy';
import WhatsAppButton from './Components/WhatsAppButton';

/*
 * Template stub pages (About, UpcomingEvents, Gallery, Artists, ReserveTable,
 * Contact, PrivacyPolicy, TermsConditions) are intentionally not routed until
 * they have real content (Phase 3).
 */

function App() {
  return (
  // reducedMotion="user": framer-motion skips transform animations when the
  // visitor has "reduce motion" enabled in their OS settings.
  <MotionConfig reducedMotion="user">
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
     <ScrollToTop />
     <a href="#main-content" className="skip-link">Skip to content</a>
     <Header />
      <div id="main-content" tabIndex="-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/events/:slug" element={<EventDetails />} />
        <Route path="/events/:slug/book" element={<EventCheckout />} />
        <Route path="/booking/:reference" element={<BookingStatus />} />
        <Route path="/ticket" element={<TicketResend />} />
        <Route path="/t" element={<TicketView />} />
        <Route path="/book" element={<BookEnquiry />} />
        <Route path={TERMS_PATH} element={<LegalPage title="Terms & Conditions" markdown={termsMarkdown} />} />
        <Route path={REFUND_POLICY_PATH} element={<LegalPage title="Refund & Cancellation Policy" markdown={refundPolicyMarkdown} />} />
        <Route path={PRIVACY_PATH} element={<LegalPage title="Privacy Policy" markdown={privacyMarkdown} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </div>
      <Footer />
      <WhatsAppButton />
      </BrowserRouter>
  </MotionConfig>
  );
}

export default App;
